var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlphaSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 0.875H0.625C0.508968 0.875 0.397688 0.921094 0.315641 1.00314C0.233594 1.08519 0.1875 1.19647 0.1875 1.3125V12.25C0.187513 12.3272 0.207965 12.4031 0.246778 12.4698C0.28559 12.5366 0.341381 12.5919 0.408482 12.6301C0.475583 12.6683 0.551603 12.6881 0.628821 12.6874C0.706038 12.6867 0.781702 12.6656 0.848125 12.6263L5 10.1369L9.15187 12.6263C9.21941 12.6663 9.29648 12.6875 9.375 12.6875C9.45016 12.6873 9.52399 12.6677 9.58937 12.6306C9.65695 12.5926 9.71323 12.5374 9.75243 12.4705C9.79164 12.4036 9.81237 12.3275 9.8125 12.25V1.3125C9.8125 1.19647 9.76641 1.08519 9.68436 1.00314C9.60231 0.921094 9.49103 0.875 9.375 0.875ZM8.9375 1.75V3.5H1.0625V1.75H8.9375ZM5.22312 9.24875C5.15662 9.21035 5.08117 9.19014 5.00437 9.19014C4.92758 9.19014 4.85213 9.21035 4.78562 9.24875L1.0625 11.4756V4.375H8.9375V11.4756L5.22312 9.24875Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphaSalesIcon);
export default __webpack_public_path__ + "static/media/alpha-sales-icon.0e72f003edc0a93f20da90dc890b3b29.svg";
export { ForwardRef as ReactComponent };